import { colors } from "../styles/variables";
import { appIds } from "../constants";

export const getTenantLogoBackgroundColor = (
  appId: string | null,
  primaryColor: string
): string => {
  switch (appId) {
    case appIds.GatoradeCom:
      return colors.black;
    case appIds.GatoradeTeamzone:
      return colors.black;
    case appIds.PantryShop:
      return primaryColor;
    case appIds.PepsiCoShop:
      return colors.white;
    case appIds.RockstarEnergy:
      return colors.white;
    default:
      return colors.white;
  }
};
